import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/index.css";
import { ADMIN_BASE } from "@/lib/config";

import Landing from "@/pages/Landing";
import CustomerMenu from "@/pages/CustomerMenu";
import SimulatePay from "@/pages/SimulatePay";
import OrderHistory from "@/pages/OrderHistory";
import AdminLogin from "@/pages/admin/AdminLogin";
import Dashboard from "@/pages/admin/Dashboard";
import Orders from "@/pages/admin/Orders";
import Products from "@/pages/admin/Products";
import Categories from "@/pages/admin/Categories";
import Modifiers from "@/pages/admin/Modifiers";
import Inventory from "@/pages/admin/Inventory";
import Tables from "@/pages/admin/Tables";
import Themes from "@/pages/admin/Themes";
import Payments from "@/pages/admin/Payments";
import Reports from "@/pages/admin/Reports";
import Settings from "@/pages/admin/Settings";
import Employees from "@/pages/admin/Employees";
import Attendance from "@/pages/admin/Attendance";
import AttendanceAdmin from "@/pages/admin/AttendanceAdmin";
import Finance from "@/pages/admin/Finance";
import Vouchers from "@/pages/admin/Vouchers";


function LegacyAdminRedirect() {
  const loc = useLocation();
  const suffix = loc.pathname.replace(/^\/omee-panel/, "");
  return (
    <Navigate
      replace
      to={`${ADMIN_BASE}${suffix}${loc.search}${loc.hash}`}
    />
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/t/:token" element={<CustomerMenu />} />
        <Route path="/pay/:orderId" element={<SimulatePay />} />
        <Route path="/history" element={<OrderHistory />} />
        <Route path="/omee-panel/*" element={<LegacyAdminRedirect />} />
        <Route path={`${ADMIN_BASE}/login`} element={<AdminLogin />} />
        <Route path={ADMIN_BASE} element={<Dashboard />} />
        <Route path={`${ADMIN_BASE}/orders`} element={<Orders />} />
        <Route path={`${ADMIN_BASE}/products`} element={<Products />} />
        <Route path={`${ADMIN_BASE}/categories`} element={<Categories />} />
        <Route path={`${ADMIN_BASE}/modifiers`} element={<Modifiers />} />
        <Route path={`${ADMIN_BASE}/inventory`} element={<Inventory />} />
        <Route path={`${ADMIN_BASE}/tables`} element={<Tables />} />
        <Route path={`${ADMIN_BASE}/themes`} element={<Themes />} />
        <Route path={`${ADMIN_BASE}/employees`} element={<Employees />} />
        <Route path={`${ADMIN_BASE}/attendance`} element={<Attendance />} />
        <Route path={`${ADMIN_BASE}/attendance-admin`} element={<AttendanceAdmin />} />
        <Route path={`${ADMIN_BASE}/payments`} element={<Payments />} />
        <Route path={`${ADMIN_BASE}/vouchers`} element={<Vouchers />} />
        <Route path={`${ADMIN_BASE}/reports`} element={<Reports />} />
        <Route path={`${ADMIN_BASE}/finance`} element={<Finance />} />
        <Route path={`${ADMIN_BASE}/settings`} element={<Settings />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
